enum ActionType {
    REQUEST_LATEST_LOCATION_THREAT_SCORES = '[CORE/LLTS] GET LATEST LOCATION THREAT SCORES',
    RECEIVE_LATEST_LOCATION_THREAT_SCORES = '[CORE/LLTS] SET LATEST LOCATION THREAT SCORES',
    LATEST_LOCATION_THREAT_SCORES_REQUEST_FAILED = '[CORE/LLTS] LATEST LOCATION THREAT SCORES REQUEST FAILED',
}

export default ActionType
